import script from "./EcommercePaymentMethods.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommercePaymentMethods.vue?vue&type=script&setup=true&lang=js"

import "./EcommercePaymentMethods.vue?vue&type=style&index=0&id=4feb039a&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4feb039a"]])

export default __exports__